import { Trans } from "@lingui/react/macro"
import classes from "./styles.module.css"

export interface INeedsNamesPillProps {
  /** How many speakers in the row still need a name. */
  count: number
  "data-testid"?: string
}

/**
 * The small amber "{n} need names" pill that leads a speaker row when something
 * still needs attention. Renders nothing once everyone is named (`count <= 0`),
 * so a host can drop it in unconditionally.
 */
export function NeedsNamesPill({ count, "data-testid": dataTestid }: INeedsNamesPillProps): React.JSX.Element | null {
  if (count <= 0) return null
  return (
    <span className={classes.needsNamesPill} data-testid={dataTestid ?? "needs-names-pill"}>
      <Trans>{count} need names</Trans>
    </span>
  )
}
